(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function FaqAccordion(root) {
    if (root.dataset.rngFaqInit === 'true') return;

    root.dataset.rngFaqInit = 'true';
    this.root = root;
    this.items = Array.from(root.querySelectorAll('[data-rng-faq-item]'));
    this.reduceMotion = prefersReducedMotion();
    this.initOpenState();
    this.bind();
    this.root.classList.add('rng-faq-accordion--initialized');
  }

  FaqAccordion.prototype.getTrigger = function (item) {
    return item.querySelector('[data-rng-faq-trigger]');
  };

  FaqAccordion.prototype.getPanel = function (item) {
    return item.querySelector('[data-rng-faq-panel]');
  };

  FaqAccordion.prototype.isOpen = function (item) {
    return item.classList.contains('is-open');
  };

  FaqAccordion.prototype.bind = function () {
    var self = this;

    this.items.forEach(function (item) {
      var trigger = self.getTrigger(item);
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        if (self.isOpen(item)) {
          self.close(item);
          return;
        }
        self.open(item);
      });
    });
  };

  FaqAccordion.prototype.initOpenState = function () {
    var self = this;
    var defaultItem = this.items.find(function (item) {
      return item.dataset.rngFaqDefaultOpen === 'true';
    });

    this.items.forEach(function (item) {
      var panel = self.getPanel(item);
      var trigger = self.getTrigger(item);
      if (!panel || !trigger) return;

      var shouldOpen = item === defaultItem;

      item.classList.toggle('is-open', shouldOpen);
      trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      panel.toggleAttribute('hidden', !shouldOpen);
      panel.style.height = shouldOpen ? 'auto' : '0px';
    });
  };

  FaqAccordion.prototype.open = function (item, animate) {
    if (this.isOpen(item)) return;

    if (animate === undefined) {
      animate = !this.reduceMotion;
    }

    var self = this;
    var panel = this.getPanel(item);
    var trigger = this.getTrigger(item);
    if (!panel || !trigger) return;

    this.items.forEach(function (other) {
      if (other !== item && self.isOpen(other)) {
        self.close(other, animate);
      }
    });

    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('hidden');

    if (!animate) {
      panel.style.height = 'auto';
      return;
    }

    panel.style.height = '0px';
    panel.offsetHeight;
    panel.style.height = panel.scrollHeight + 'px';

    panel.addEventListener(
      'transitionend',
      function onEnd(event) {
        if (event.target !== panel || event.propertyName !== 'height') return;
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', onEnd);
      }
    );
  };

  FaqAccordion.prototype.close = function (item, animate) {
    if (animate === undefined) {
      animate = !this.reduceMotion;
    }

    var panel = this.getPanel(item);
    var trigger = this.getTrigger(item);
    if (!panel || !trigger || !this.isOpen(item)) return;

    item.classList.remove('is-open');
    trigger.setAttribute('aria-expanded', 'false');

    if (!animate) {
      panel.style.height = '0px';
      panel.setAttribute('hidden', '');
      return;
    }

    panel.style.height = panel.scrollHeight + 'px';
    panel.offsetHeight;
    panel.style.height = '0px';

    panel.addEventListener(
      'transitionend',
      function onEnd(event) {
        if (event.target !== panel || event.propertyName !== 'height') return;
        panel.setAttribute('hidden', '');
        panel.removeEventListener('transitionend', onEnd);
      }
    );
  };

  function initFaqAccordion() {
    document.querySelectorAll('[data-rng-faq-accordion]').forEach(function (root) {
      new FaqAccordion(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAccordion);
  } else {
    initFaqAccordion();
  }
})();
